module.exports = __webpack_public_path__ + "img/NodeJs.23f6eaec.svg";